import { PaymentMethod, type CompanyGig } from "model/Gig";
import type {
  UpdateGigPayload,
  UpdateGigShiftPayload,
} from "services/api/company/gig.service";
import type {
  EditPaymentType,
  EditSkillItem,
} from "./teamPublicDetailsModal.contract";

interface BuildUpdateGigPayloadParams {
  gigData: CompanyGig;
  editPaymentType: EditPaymentType;
  editRole: string;
  editDescription: string;
  parsedMinRate: number;
  parsedMaxRate: number;
  parsedAmountOfWorkers: number;
  editSkills: ReadonlyArray<EditSkillItem>;
}

/**
 * Maps gig shifts to API payload format.
 */
const mapShifts = (gigData: CompanyGig): UpdateGigShiftPayload[] => {
  return gigData.shifts.map((shift) => ({
    id: shift.id,
    startTime: shift.startTime,
    endTime: shift.endTime,
    breakStartTime: shift.breakStartTime ?? null,
    breakEndTime: shift.breakEndTime ?? null,
    deductionAmount: shift.deductionAmount ?? 0,
  }));
};

/**
 * Builds payload for updating a team public gig from edit state.
 */
export const buildUpdateGigPayload = (
  params: BuildUpdateGigPayloadParams,
): UpdateGigPayload => {
  return {
    paymentType: params.editPaymentType || PaymentMethod.NONE,
    role: params.editRole.trim(),
    description: params.editDescription.trim(),
    minRate: params.parsedMinRate,
    maxRate: params.parsedMaxRate,
    amountOfWorkers: params.parsedAmountOfWorkers,
    workGroupId: params.gigData.workGroupId,
    shifts: mapShifts(params.gigData),
    skills: params.editSkills.map((skillItem) => ({
      id: skillItem.type === "persisted" ? skillItem.id : undefined,
      skill: skillItem.skill,
      experience: 0,
    })),
  };
};
